import { render } from "./paid.vue?vue&type=template&id=42b54ed6&scoped=true"
import script from "./paid.vue?vue&type=script&lang=js"
export * from "./paid.vue?vue&type=script&lang=js"

import "./paid.vue?vue&type=style&index=0&id=42b54ed6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b54ed6"]])

export default __exports__